import React, { ButtonHTMLAttributes, FC } from 'react';
import clsx from 'clsx';

import styles from './IconButton.module.scss';

enum IconButtonVariants {
  SIMPLE = 'simple',
  ROUNDED = 'rounded',
  EXPAND = 'expand',
  ACCENT = 'accent',
}

type IconButtonSizeType = 'extra-small' | 'small' | 'medium' | 'big';

type IconPlacementType = 'on-surface' | 'on-bg' | 'on-color-fill';

type IconButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  variant: IconButtonVariants;
  placement?: IconPlacementType;
  size?: IconButtonSizeType;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void | Promise<void>;
  isLoading?: boolean;
  Icon: FC;
  StartIcon?: FC<{ color?: string; size?: number }>;
  EndIcon?: FC<{ color?: string; size?: number }>;
  className?: string;
};

const IconButton = ({
  onClick,
  variant,
  size = 'medium',
  placement = 'on-bg',
  isLoading,
  Icon,
  StartIcon,
  EndIcon,
  className,
  ...props
}: IconButtonProps) => (
  <button
    onClick={onClick}
    className={clsx(
      styles.button,
      styles[variant],
      styles[size],
      styles[placement],
      {
        [styles.is_with_icons]: StartIcon || EndIcon,
      },
      className,
    )}
    aria-disabled={isLoading}
    {...props}
  >
    {isLoading ? (
      <span className={styles.loader}></span>
    ) : (
      <>
        {StartIcon && (
          <div className={styles.start_icon}>
            <StartIcon />
          </div>
        )}
        <div className={styles.icon}>
          <Icon />
        </div>
        {EndIcon && (
          <div className={styles.end_icon}>
            <EndIcon />
          </div>
        )}
      </>
    )}
  </button>
);

export { IconButton, type IconButtonProps, IconButtonVariants };
